module.exports = __webpack_public_path__ + "img/bg2.a30ee8d6.png";